import { mediaField } from './media';

export const TEAM = `
query Persons($locale: LocaleInputType) {
  Persons(limit: 200, locale: $locale) {
    docs {
      id
      department
      nickname
      lastName
      firstName
      visible
      ${mediaField('image')}
    }
  }
}
`;
